import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/notificationemails`;

export interface NotificationEmail {
  id: number;
  branch: string;
  warehouse: string;
  email: string;
  isEnabled: boolean;
  createdDateTime: string;
}

const authConfig = async (instance: IPublicClientApplication, account: any) => {
  const response = await instance.acquireTokenSilent({ ...apiRequest, account });
  return { headers: { Authorization: `Bearer ${response.accessToken}` } };
};

export const getNotificationEmails = async (
  instance: IPublicClientApplication,
  account: any,
): Promise<{ smtpConfigured: boolean; items: NotificationEmail[] }> => {
  const config = await authConfig(instance, account);
  const res = await axios.get(API_URL, config);
  return res.data;
};

export const createNotificationEmail = async (
  instance: IPublicClientApplication,
  account: any,
  data: { branch: string; warehouse: string; email: string },
): Promise<NotificationEmail> => {
  const config = await authConfig(instance, account);
  const res = await axios.post<NotificationEmail>(API_URL, data, config);
  return res.data;
};

export const setNotificationEmailEnabled = async (
  instance: IPublicClientApplication,
  account: any,
  id: number,
  isEnabled: boolean,
): Promise<void> => {
  const config = await authConfig(instance, account);
  await axios.put(`${API_URL}/${id}`, { isEnabled }, config);
};

export const deleteNotificationEmail = async (
  instance: IPublicClientApplication,
  account: any,
  id: number,
): Promise<void> => {
  const config = await authConfig(instance, account);
  await axios.delete(`${API_URL}/${id}`, config);
};

export const sendTestNotificationEmail = async (
  instance: IPublicClientApplication,
  account: any,
  id: number,
): Promise<void> => {
  const config = await authConfig(instance, account);
  await axios.post(`${API_URL}/${id}/test`, null, config);
};
